

















import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
@Component
export default class Attach extends Vue {
  @Prop() type: any
  @Prop() attach: any
}
